import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
const parts = ['WEB', 'WHATSAPP', 'IA', 'CRM', 'CALENDARIO', 'AUTOMATIZACIONES'];
export function OriginSystem() {
  return <section id="sistema" className="bg-arena py-[72px] md:py-[120px]" data-id="element-244" data-mp="2rzs4xlk1su8p">
      <div className="max-w-[1200px] mx-auto px-6 md:px-20" data-id="element-245" data-mp="2wz51iy0q1foh">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="mb-16 md:mb-20 text-center max-w-[640px] mx-auto" data-id="element-246" data-mp="2x1r8owjp9t66">
          <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-[0.15em] mb-4" data-id="element-247" data-mp="208vt8o9q4vn0">
            CÓMO FUNCIONA
          </span>
          <h2 className="font-display text-[32px] md:text-[48px] font-bold text-carbon leading-[1.1]" data-id="element-248" data-mp="24d3icmk3gdlr">
            Un sistema. No otra herramienta.
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        ease: 'easeOut',
        delay: 0.1
      }} className="flex flex-wrap items-center justify-center gap-3 md:gap-4" data-id="element-249" data-mp="41nzly7t3pur">
          {parts.map((part, idx) => <Fragment key={part} data-id="element-250" data-mp="1x4jib8ynkf" data-mpi={idx}>
              <span className="font-display text-[14px] md:text-[17px] font-semibold text-carbon bg-arena-dark border border-carbon/10 rounded-[8px] px-4 py-2.5" data-id="element-251" data-mp="3rfjod0k46aze">
                {part}
              </span>
              {idx < parts.length - 1 && <span className="font-display text-[16px] text-carbon/30" data-id="element-252" data-mp="2yq2wq54biy48">
                  +
                </span>}
            </Fragment>)}
          <span className="font-display text-[16px] text-carbon/30" data-id="element-253" data-mp="3sfjtokv6ftf4">=</span>
          <span className="font-display text-[14px] md:text-[17px] font-bold text-arena bg-verde rounded-[8px] px-5 py-2.5" data-id="element-254" data-mp="11xmq37es0hk">
            ORIGEN
          </span>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        delay: 0.3
      }} className="flex flex-col sm:flex-row items-center justify-center gap-8 sm:gap-16 mt-10 text-center" data-id="element-255" data-mp="62lamg0cc17k">
          <div data-id="element-256" data-mp="tquw1gtn6my6">
            <div className="h-px w-16 bg-carbon/15 mx-auto mb-2" data-id="element-257" data-mp="tpa0bnvlcxyq" />
            <span className="font-body text-[12px] uppercase tracking-[0.1em] text-salvia" data-id="element-258" data-mp="yp64bn4agpea">
              Presencia Digital
            </span>
          </div>
          <div data-id="element-259" data-mp="2j6p0gta95q1b">
            <div className="h-px w-16 bg-carbon/15 mx-auto mb-2" data-id="element-260" data-mp="2j9b80sx585jj" />
            <span className="font-body text-[12px] uppercase tracking-[0.1em] text-salvia" data-id="element-261" data-mp="2e9ox4q4sf1dw">
              Automatización con IA
            </span>
          </div>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: 0.4
      }} className="text-center font-body text-[14px] text-carbon/50 mt-12 max-w-[480px] mx-auto" data-id="element-262" data-mp="24hj55gejcjyp">
          Cada sistema empieza con un diagnóstico{' '}
          <Link to="/diagnostico" className="text-verde font-medium hover:underline" data-id="element-263" data-mp="1lm2tjhvk7wr1">
            ICD™
          </Link>{' '}
          de tu presencia digital y automatización.
        </motion.p>
      </div>
    </section>;
}